var pomlo_app = {};

// Define constants
pomlo_app.MOBILE_MAX_WIDTH = 768;
pomlo_app.TABLET_MAX_WIDTH = 992;
pomlo_app.DEFAULT_DURATION = 300;
pomlo_app.HEADER_HEIGHT = 0;

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sParameterName;

  sParameterName = sPageURL.split('=');

  if (sParameterName[0] === sParam) {
    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
  }

};

pomlo_app.updateMembersDisplay = function () {
  jQuery('.members').each(function () {
    var $member = jQuery(this);
    var hasLogo = $member.find('.members--logo').length > 0;
    if (jQuery('#switchCheckDefault').is(':checked')) {
      var hasPortrait = $member.find('.members--director').length > 0;
      if (hasPortrait) {
        $member.find('.members--director').show();
        $member.find('.members--logo').hide();
        $member.find('.members--title').hide();
      } else if (hasLogo) {
        $member.find('.members--logo').show();
        $member.find('.members--title').hide();
      } else {
        $member.find('.members--title').show();
      }
    } else {
      if (hasLogo) {
        $member.find('.members--logo').show();
        $member.find('.members--director').hide();
        $member.find('.members--title').hide();
      } else {
        $member.find('.members--title').show();
        $member.find('.members--director').hide();
      }
    }
  });
}

jQuery(document).ready(function ($) {
  //To go to pages anchors
  var autoscroll = getUrlParameter('autoscroll');

  if (autoscroll) {
    window.scrollTo(0, $(':target').offset().top - $('#navbarBox').outerHeight(true));
  }

  pomlo_app.updateMembersDisplay();
  $('#switchCheckDefault').on('change', function () {
    pomlo_app.updateMembersDisplay();
  });

  // Init interface
  $('#partnersGallery').owlCarousel({
    loop: true,
    autoplay: false,
    nav: true,
    navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
    dots: false,
    margin: 15,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      }
    }
  });

  // Init interface
  $('#articlesGallery').owlCarousel({
    loop: true,
    autoplay: false,
    nav: true,
    navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
    dots: false,
    margin: 15,
    items: 1,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: $('.owl-carousel .item').length > 1 ? 2 : 1,
      },
    }
  });


  //Init lightcase
  $('a[data-rel^=lightcase]').lightcase({
    maxWidth: 1024,
    maxHeight: 768,
    video: {
      width: 640,
      height: 360,
    },
    onBeforeShow: {
      hackZIndex: function () {
        // hack z-index lightcase component as modification in css does not seems to apply (see _custom.scss)
        $('#lightcase-overlay').css('z-index', '2000');
        $('#lightcase-loading').css('z-index', '2001');
        $('#lightcase-case').css('z-index', '2002');
        $('#lightcase-nav').css('z-index', '2003');
        $('a[class^="lightcase-icon-"]').css('z-index', '2004');
      }
    },
  });

  pomloUIBlock.setBlockHeight("#blockMembers");

  $('.sf-input-text').keypress(function(event) {
    if (event.keyCode == 13) {
      event.preventDefault();
    }
  });
});

jQuery(window).scroll(function () {

});

jQuery(window).resize(function () {
  pomloUIBlock.setBlockHeight("#blockMembers");
});
